<template>
  <b-container fluid class="mt-5 pt-5 mb-5 pb-5">
    <b-card-group columns v-if="registros.length">
      <b-card bg-variant="light" v-bind:key="data.CODIGO" v-for="data in registros"
        v-bind:title="data.CODIGO"
        v-bind:img-src= "rutaFoto(data.PHOTO)"
        img-alt=""
        img-top
        tag="article">
        <b-card-text>
          <hr />
          <div class="font-weight-bold">{{ `${data.FAMILIA.slice(0,30)}...` }}</div>
          <div>{{ data.DESCRIPCION }}</div>
          <div><small class="font-italic">{{ data.ALTO }} * {{ data.ANCHO }} * {{ data.FONDO }}</small></div>
        </b-card-text>
        <!--<b-card-text>{{ `${data.strCategoryDescription.slice(0,100)}...` }}</b-card-text>
        <b-button pill size="sm" variant="primary" class="position-absolute" style="top: 7px; right: 7px;">
          <b-icon font-scale="0.9" shift-v="4" icon="image-fill" variant="light"></b-icon>
        </b-button>-->


        <image-uploader
        :preview="false"
        :className="['fileinput']"
        :maxWidth=600
        capture="environment"
        :debug="2"
        accept=".jpg,.jpeg"
        doNotResize="gif"
        :autoRotate="true"
        outputFormat="verbose"
        @input="setImage"
        @onUpload="subiendo"
        @onComplete="subido"
        >
          <label for="fileInput" slot="upload-label" class="position-absolute labelInput" style="top: 7px; right: 7px;" @click="setArticulo(data.CODIGO)" title="Haz click para añadir/cambiar imagen">
            <figure>
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none" d="M9.969,0.594c-5.195,0-9.406,4.211-9.406,9.406c0,5.195,4.211,9.406,9.406,9.406c5.195,0,9.406-4.211,9.406-9.406C19.375,4.805,15.164,0.594,9.969,0.594 M9.969,18.552c-4.723,0-8.551-3.829-8.551-8.552s3.829-8.551,8.551-8.551S18.521,5.277,18.521,10S14.691,18.552,9.969,18.552 M12.534,5.724H7.403c-0.944,0-1.71,0.766-1.71,1.71v5.131c0,0.944,0.766,1.71,1.71,1.71h5.131c0.944,0,1.71-0.766,1.71-1.71V7.435C14.244,6.49,13.479,5.724,12.534,5.724M11.679,7.007h1.283V8.29h-1.283V7.007z M9.969,8.29c0.944,0,1.71,0.766,1.71,1.71s-0.766,1.71-1.71,1.71s-1.71-0.766-1.71-1.71S9.024,8.29,9.969,8.29 M13.39,12.565c0,0.472-0.384,0.854-0.855,0.854H7.403c-0.472,0-0.855-0.383-0.855-0.854V9.573h0.898C7.423,9.712,7.403,9.854,7.403,10c0,1.417,1.149,2.565,2.565,2.565c1.416,0,2.565-1.148,2.565-2.565c0-0.146-0.02-0.288-0.043-0.427h0.898V12.565z"></path>
              </svg>
            </figure>
          </label>
        </image-uploader>

      </b-card>
    </b-card-group>
    <!--b-alert show variant="danger" v-if="!registros.length && $store.state.registros.length">No hay registros...</b-alert>-->
    <b-alert show variant="secondary" v-if="!$store.state.registros.length">Cargando...</b-alert>
    
  </b-container>
</template>

<script>

  export default {
    name: "Tarjetas",
    data(){
      return {
        image: null,
        articulo: null
      }
    },
    mounted() {
      this.$store.commit('obtenerDatos')
    },
    computed:{
      registros: function(){return this.$store.state.registrosFiltrados}
    },
    methods: {
      setImage: function(output) {
        //this.image = output;

        //console.log(output);
        //console.log(this.articulo);

        this.$store.commit('subirImagen', {img: output.dataUrl, nombre: this.articulo});
        
      },
      subiendo: function(){
        console.log("subiendo");
      },
      subido: function(){
        console.log("subido");
      },
      setArticulo: function(articulo){
        this.articulo = articulo;
      },
      rutaFoto: function (foto){
        if (foto.indexOf('data')<0){
          return '/assets/' + foto
        }
        return foto;
      }
      
    }
  }

</script>

<style>

  /* -----
  SVG Icons - svgicons.sparkk.fr
  ----- */

  .svg-icon {
    width: 1.8em;
    height: 1.8em;
  }

  .svg-icon path,
  .svg-icon polygon,
  .svg-icon rect {
    fill: #4691f6;
  }

  .svg-icon circle {
    stroke: #4691f6;
    stroke-width: 1;
  }

  .labelInput{
    cursor:pointer;
  }

  #fileInput {
    display: none;
  }
  @media (min-width:356px) {
      .card-columns {
        column-count: 1 !important;
      }
  }

  @media (min-width:576px) {
      .card-columns {
        column-count: 2 !important;
      }
  }
  @media (min-width:768px) {
      .card-columns {
        column-count: 3 !important;
      }
  }
  @media (min-width:992px) {
      .card-columns {
        column-count: 4 !important;
      }
  }
  @media (min-width:1200px) {
      .card-columns {
        column-count: 5 !important;
      }
  }
  article{
    color: #464b4f;
  }
  img {
    font-weight: 300;
    line-height: 2;  
    text-align: center;
    
    width: 100%;
    height: auto;
    display: block;
    position: relative;
    min-height: 100px;
    width: 100%;
  }

  img:before { 
    content: " ";
    display: block;
    position: absolute;
    top: 0px;
    left: 0;
    height: calc(100% + 10px);
    width: 100%;
    background-color: rgb(230, 230, 230);
    border-radius: calc(.25rem - 1px);
  }

  img:after { 
    content: "Pendiente de imagen";
    display: block;
    font-size: 18px;
    font-style: normal;
    color: rgb(100, 100, 100);
    position: absolute;
    top: 35px;
    left: 0;
    width: 100%;
    text-align: center;
  }

</style>